import { PieChart as BaseChart } from 'react-minimal-pie-chart';

function DataLabel(dataEntry) {
  const percentage = dataEntry.percentage;
  const percentageLabel = `${Math.round(percentage)} %`;
  return percentage > 0 ? percentageLabel : '';
}

const PieChart = ({ data, style = { height: '150px' } }) => {
  return (
    <BaseChart
      data={data}
      style={style}
      labelPosition={120}
      labelStyle={{ fontSize: '10px', fontFamily: 'sans-serif' }}
      label={({ dataEntry }) => DataLabel(dataEntry)}
    />
  );
};

export default PieChart;
